'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPane = function TabPane(props) {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.cloneElement(props.children, { 'isActive': props.isActive })
    );
};

TabPane.propTypes = {
    label: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.element.isRequired
};

exports.default = TabPane;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/TabPane.js
// module id = 489
// module chunks = 0